export type Operation = {
    currentFieldNum: number;
    currentLine: number;
    currentFieldValue: string;
    key: number;
    isActive: string;
    currentTab: number;
    isPainted: boolean;
};

export function isPainted(table: string) {
    return window['netForm'] && window['netForm'].isPainted && window['netForm'].isPainted(table);
}

export function updateSortIndication(
    tableId: number,
    fieldId: number,
    isSort: boolean,
    isDesc: boolean
) {
    return (
        window['netForm'] &&
        window['netForm'].updateSortIndication &&
        window['netForm'].updateSortIndication(tableId, fieldId, isSort, isDesc)
    );
}

export function setIsForceSendValueToServer(value) {
    return (
        window['netForm'] &&
        window['netForm'].setIsForceSendValueToServer &&
        window['netForm'].setIsForceSendValueToServer(value)
    );
}

export function removeZoomingFlag() {
    return (
        window['netForm'] &&
        window['netForm'].removeZoomingFlag &&
        window['netForm'].removeZoomingFlag()
    );
}

export function resetZoomBtnStatus() {
    return (
        window['netForm'] &&
        window['netForm'].resetZoomBtnStatus &&
        window['netForm'].resetZoomBtnStatus()
    );
}

export function formZoom(mode) {
    window['netForm'] && window['netForm'].formZoom && window['netForm'].formZoom(mode);
}

export function isNetFormOnTop() {
    return (
        window['netForm'] && window['netForm'].isNetFormOnTop && window['netForm'].isNetFormOnTop()
    );
}

export function isPopup() {
    return window['netForm'] && window['netForm'].isPopup && window['netForm'].isPopup();
}

export function getIsForceSendValueToServer() {
    return (
        window['netForm'] &&
        window['netForm'].getIsForceSendValueToServer &&
        window['netForm'].getIsForceSendValueToServer()
    );
}

export function setIsReactPopupOpen(value: boolean) {
    window['netForm'] &&
        window['netForm'].setIsReactPopupOpen &&
        window['netForm'].setIsReactPopupOpen(value);
}

export function setHasModalChild(value: boolean) {
    window['netForm'] &&
        window['netForm'].setHasModalChild &&
        window['netForm'].setHasModalChild(value);
}

export function getHasModalChild() {
    return (
        window['netForm'] &&
        window['netForm'].getHasModalChild &&
        window['netForm'].getHasModalChild()
    );
}

export function prepareExecuteSearch(index) {
    window['netForm'] &&
        window['netForm'].prepareExecuteSearch &&
        window['netForm'].prepareExecuteSearch(index);
}

export function quickSearchEntStart(index) {
    window['netForm'] &&
        window['netForm'].quickSearchEntStart &&
        window['netForm'].quickSearchEntStart(index);
}

export function addFormOperation(operation: Operation) {
    const {currentFieldNum, currentLine, currentFieldValue, key, isActive, currentTab, isPainted} =
        operation;

    window['netForm'] &&
        window['netForm'].addFormOperation &&
        window['netForm'].addFormOperation(
            currentFieldNum,
            currentLine,
            currentFieldValue,
            key,
            isActive,
            currentTab,
            isPainted
        );
}

export function gwtBuildFormServerCall(
    methodName,
    parameters,
    reason,
    isProcessServerAnswerGWT,
    callback,
    showLoader,
    addToQueue,
    session = null,
    userState = ''
) {
    return (
        window['netForm'] &&
        window['netForm'].buildServerCall &&
        window['netForm'].buildServerCall(
            methodName,
            parameters,
            reason,
            isProcessServerAnswerGWT,
            callback,
            showLoader,
            addToQueue,
            session,
            userState
        )
    );
}

export function addChooseStateXml(sortOption, chooseId) {
    window['netForm'] &&
        window['netForm'].addChooseStateXml &&
        window['netForm'].addChooseStateXml(sortOption, chooseId);
}

export function excecuteActivationByName(ename) {
    window['netForm'] &&
        window['netForm'].excecuteActivationByName &&
        window['netForm'].excecuteActivationByName(ename);
}

export function getServerReason() {
    return (
        window['netForm'] &&
        window['netForm'].getServerReason &&
        window['netForm'].getServerReason()
    );
}

export function getTimeStamp() {
    return window['netForm'] && window['netForm'].getTimeStamp && window['netForm'].getTimeStamp();
}

export function isOnServer() {
    return window['netForm'] && window['netForm'].isOnServer && window['netForm'].isOnServer();
}
export function pasteColumn(pasteData: string) {
    window['netForm'] && window['netForm'].pasteColumn && window['netForm'].pasteColumn(pasteData);
}

export function handlePartModalInsertion(
    selectedItems: Array<{colName: string; value: string; shouldEnterRecord: string}>,
    index: number
) {
    window['netForm'] &&
        window['netForm'].handlePartModalInsertion &&
        window['netForm'].handlePartModalInsertion(selectedItems, index);
}

export function startForm(formName) {
    return (
        window['netForm'] &&
        window['netForm'].StartFormEnt &&
        window['netForm'].StartFormEnt(formName)
    );
}

export function prepareHelpMessage(exec) {
    return (
        window['netForm'] &&
        window['netForm'].getEntityHelpMessage &&
        window['netForm'].getEntityHelpMessage(exec)
    );
}

export function showFormDesignPanel(type: string) {
    return (
        window['netForm'] &&
        window['netForm'].OpenFormDesignPanel &&
        window['netForm'].OpenFormDesignPanel(type)
    );
}

export function getFieldDesignDataSet(type, list) {
    return (
        window['netForm'] &&
        window['netForm'].getFieldDesignDataSet &&
        window['netForm'].getFieldDesignDataSet(type, list)
    );
}

export function endFormDesign(dataSet, type: string) {
    window['netForm'] &&
        window['netForm'].endFormDesign &&
        window['netForm'].endFormDesign(dataSet, type);
}
export function deleteMacro(macroID) {
    return (
        window['netForm'] && window['netForm'].deleteMacro && window['netForm'].deleteMacro(macroID)
    );
}

export function activateMacro(macroID, ds) {
    return (
        window['netForm'] &&
        window['netForm'].activateMacro &&
        window['netForm'].activateMacro(macroID, ds)
    );
}

export function startRecordingMacro(dataSet) {
    return (
        window['netForm'] &&
        window['netForm'].startRecordingMacro &&
        window['netForm'].startRecordingMacro(dataSet)
    );
}

export function stopRecordingMacro(isRecursive) {
    return (
        window['netForm'] &&
        window['netForm'].stopRecordingMacro &&
        window['netForm'].stopRecordingMacro(isRecursive)
    );
}

export function addMacroAction(macroID) {
    return (
        window['netForm'] &&
        window['netForm'].addMacroAction &&
        window['netForm'].addMacroAction(macroID)
    );
}

export function toggleRecursiveActionAndReturnData(macroID, dataSet, isRecursive) {
    return (
        window['netForm'] &&
        window['netForm'].toggleRecursiveActionAndReturnData &&
        window['netForm'].toggleRecursiveActionAndReturnData(macroID, dataSet, isRecursive)
    );
}

export function stopMacroMsg(msg) {
    return (
        window['netForm'] &&
        window['netForm'].stopMacroMessage &&
        window['netForm'].stopMacroMessage(msg)
    );
}

export function isPersonalizationSource() {
    return (
        window['netForm'] &&
        window['netForm'].isPersonalizationSource &&
        window['netForm'].isPersonalizationSource()
    );
}

export function getReconSide(session: string) {
    return (
        window['netForm'] &&
        window['netForm'].getReconSide &&
        window['netForm'].getReconSide(session)
    );
}

export function isMacroActive() {
    return (
        window['netForm'] && window['netForm'].IsMacroActive && window['netForm'].IsMacroActive()
    );
}

export function getIsBlockedCommands() {
    return (
        window['netForm'] &&
        window['netForm'].getIsBlockedCommands &&
        window['netForm'].getIsBlockedCommands()
    );
}

export function isCurrentNetformCollectingUserActions() {
    return (
        window['netForm'] &&
        window['netForm'].isCurrentNetformCollectingUserActions &&
        window['netForm'].isCurrentNetformCollectingUserActions()
    );
}

export function getIsActionSource() {
    return (
        window['netForm'] &&
        window['netForm'].getIsActionSource &&
        window['netForm'].getIsActionSource()
    );
}

export function getZoomSourceName() {
    return (
        window['netForm'] &&
        window['netForm'].getZoomSourceName &&
        window['netForm'].getZoomSourceName()
    );
}

export function getTargetZoomName() {
    return (
        window['netForm'] &&
        window['netForm'].getTargetZoomName &&
        window['netForm'].getTargetZoomName()
    );
}

export function invokeSnoozedSubFormsSuggestion() {
    return (
        window['netForm'] &&
        window['netForm'].invokeSnoozedSubFormsSuggestion &&
        window['netForm'].invokeSnoozedSubFormsSuggestion()
    );
}

export function invalidateCurrent(session: string) {
    return (
        window['netForm'] &&
        window['netForm'].invalidateCurrent &&
        window['netForm'].invalidateCurrent(session)
    );
}

export function runForm(
    formName: string,
    zoomColumn: number,
    columnName: string,
    value: string,
    isActionSource: boolean,
    isQueryMode: boolean,
    dname: string
) {
    window['netForm'] &&
        window['netForm'].runForm &&
        window['netForm'].runForm(
            formName,
            zoomColumn,
            columnName,
            value,
            isActionSource,
            isQueryMode,
            dname
        );
}

export function navigateBackFromOldUi(level: number, session: string) {
    window['netForm'] &&
        window['netForm'].navigateBackFromOldUi &&
        window['netForm'].navigateBackFromOldUi(level, session);
}

export function isNewApiForm(ename: string) {
    return (
        window['netForm'] && window['netForm'].isNewApiForm && window['netForm'].isNewApiForm(ename)
    );
}

export function formAlertReport(name: string, callback: () => void) {
    return (
        window['netForm'] &&
        window['netForm'].formAlertReport &&
        window['netForm'].formAlertReport(name, callback)
    );
}

export function setNFormFatalError() {
    return window['netForm']?.setNFormFatalError?.();
}

export function triggerHeaderRerender() {
    return window['netForm']?.triggerHeaderRerender?.();
}

export function refreshNetform() {
    return window['netForm']?.refreshNetform?.();
}

export function setNetformIsDesigning(value: boolean) {
    return window['netForm']?.setNetformIsDesigning?.(value);
}

export function refreshSidePanels() {
    return window['netForm']?.refreshSidePanels?.();
}

export function isCurrentRowNew() {
    return window['netForm']?.isCurrentRowNew?.();
}

export function setReloadOnExit(value: boolean) {
    window['netForm']?.setReloadOnExit?.(value);
}
